/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import claims from "../../http/requests/claims"


export default {
    ADD_CLAIMS(state, item) {
        state.employeeFiledClaims.unshift(item)
    },
    UPDATE_CLAIMS(state, item) {
        const index = state.employeeFiledClaims.findIndex((e) => e.employeeFiledClaimsId === item.employeeFiledClaimsId)
        Object.assign(state.employeeFiledClaims[index], item)
    },
    ADD_CLAIMSDETAILS(state, item) {
        state.employeeFiledClaimsDetails.unshift(item)
    },
    UPDATE_CLAIMSDETAILS(state, item) {
        state.employeeFiledClaimsDetails = item
        // const index = state.employeeFiledClaimsDetails.findIndex((e) => e.id === item.id)
        // Object.assign(state.employeeFiledClaimsDetails[index], item)
    },
    DELETE_CLAIMSDETAILS(state, item) {
        state.employeeFiledClaimsDetails= item
    },
    GET_CLAIMSDETAILS_BY_CLAIMSID(state, claimsDetails) {
        state.claimsDetails = claimsDetails
    },
    GET_ALL_CLAIMS(state, payload) {
        state.employeeFiledClaims = payload
    },
    
    UPLOAD_PHOTO(state, photo){
        state.photoUpload.unshift(photo)
    },
    GET_ALL_APPROVERS(state, approvers){
        state.approvers = approvers
    },
    UNSUBMIT_CLAIMS(state, claimsId){
        //console.log('okay')
        //console.log(claimsId)
        const index = state.employeeFiledClaims.findIndex((e) => e.employeeFiledClaimsId === claimsId)
        Object.assign(state.employeeFiledClaims[index], {
            isDraft: true, 
            isSubmitted: false})
        
        
    },
    CANCELLED_CLAIMS(state, items){
        const index = state.employeeFiledClaims.findIndex((e) => e.employeeFiledClaimsId === items.employeeFiledClaimsId)
        Object.assign(state.employeeFiledClaims[index], { 
            isDraft: items.isDraft, 
            isSubmitted: items.isSubmitted, 
            isCancelled: items.isCancelled, 
            remarks: items.remarks, 
            isReviewerRevised: items.isReviewerRevised, 
            isApproverRevised: items.isApproverRevised })
    },
    RETRACKED_CLAIMS(state, items){
        const index = state.employeeFiledClaims.findIndex((e) => e.employeeFiledClaimsId === items.employeeFiledClaimsId)
        Object.assign(state.employeeFiledClaims[index], {
            isDraft: items.isDraft, 
            isRetracted: items.isRetracted,
            retractedOn: items.retractedOn,
            isReviewerApproved: items.isReviewerApproved,
            isApproverApproved: items.isApproverApproved,
            remarks: items.remarks})

    },
    REVIEWED_CLAIMS(state, items){
        const index = state.employeeFiledClaims.findIndex((e) => e.employeeFiledClaimsId === items.employeeFiledClaimsId)
        Object.assign(state.employeeFiledClaims[index], {
            isReviewerUnread : items.isReviewerUnread, 
            isReviewerApproved: items.isReviewerApproved, 
            reviewerApprovedOn : items.reviewerApprovedOn, 
            isRetracted : items.isRetracted
        })

       
    },
    REVIEWERDENIED_CLAIMS(state, items){
        const index = state.employeeFiledClaims.findIndex((e) => e.employeeFiledClaimsId === items.employeeFiledClaimsId)
        Object.assign(state.employeeFiledClaims[index], {
            isReviewerUnread : items.isReviewerUnread, 
            isReviewerDenied: items.isReviewerDenied, 
            reviewerDeniedOn : items.reviewerDeniedOn, 
            isRetracted : items.isRetracted, 
            reviewerComments: items.reviewerComments,
        })
    },
    REVIEWERREVISED_CLAIMS(state, items){
        const index = state.employeeFiledClaims.findIndex((e) => e.employeeFiledClaimsId === items.employeeFiledClaimsId)
        Object.assign(state.employeeFiledClaims[index], {
            isReviewerUnread : items.isReviewerUnread, 
            isReviewerRevised: items.isReviewerRevised, 
             reviewerForRevisionOn : items.reviewerForRevisionOn, 
            isRetracted : items.isRetracted, 
            reviewerComments: items.reviewerComments,
        })
    },
    APPROVED_CLAIMS(state, items){
        const index = state.employeeFiledClaims.findIndex((e) => e.employeeFiledClaimsId === items.employeeFiledClaimsId)
        Object.assign(state.employeeFiledClaims[index], {
            isReviewerUnread : items.isReviewerUnread, 
            isReviewerApproved: items.isReviewerApproved, 
            reviewerApprovedOn : items.reviewerApprovedOn, 
            isRetracted : items.isRetracted
        })

       
    },
    APPROVERDENIED_CLAIMS(state, items){
        const index = state.employeeFiledClaims.findIndex((e) => e.employeeFiledClaimsId === items.employeeFiledClaimsId)
        Object.assign(state.employeeFiledClaims[index], {
            isReviewerUnread : items.isReviewerUnread, 
            isReviewerDenied: items.isReviewerDenied, 
            reviewerDeniedOn : items.reviewerDeniedOn, 
            isRetracted : items.isRetracted, 
            reviewerComments: items.reviewerComments,
        })
    },
    APPROVERREVISED_CLAIMS(state, items){
        const index = state.employeeFiledClaims.findIndex((e) => e.employeeFiledClaimsId === items.employeeFiledClaimsId)
        Object.assign(state.employeeFiledClaims[index], {
            isReviewerUnread : items.isReviewerUnread, 
            isReviewerRevised: items.isReviewerRevised, 
             reviewerForRevisionOn : items.reviewerForRevisionOn, 
            isRetracted : items.isRetracted, 
            reviewerComments: items.reviewerComments,
        })
    },
}
    